module.exports = __webpack_public_path__ + "img/gw.b4efe7e1.svg";